import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _sliceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/slice";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context2; _forEachInstanceProperty(_context2 = ownKeys(Object(source), true)).call(_context2, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context3; _forEachInstanceProperty(_context3 = ownKeys(Object(source))).call(_context3, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { Children, useRef, useCallback, useEffect, useImperativeHandle, forwardRef } from 'react';
import { useStyles, StyleSheet, text, icon, padding, margin, border } from '@rexlabs/styling';
import { noop, uniqueId, isString } from 'lodash';
var CHECKBOX = 'checkbox';
var RADIO = 'radio';

function prepend(value, array) {
  var newArray = _sliceInstanceProperty(array).call(array);

  newArray.unshift(value);
  return newArray;
}

var checkboxLabelStyles = StyleSheet({
  label: _objectSpread(_objectSpread(_objectSpread({}, text.styles({
    target: 'checkbox.label',
    fallback: 'normal.default'
  })), margin.styles({
    target: 'checkbox.label',
    top: 'xxxs'
  })), {}, {
    '& > svg': _objectSpread({}, icon.styles({
      target: 'checkbox.label',
      size: 's'
    }))
  })
});

function CheckboxLabel(_ref) {
  var id = _ref.id,
      label = _ref.label,
      children = _ref.children;
  var s = useStyles(checkboxLabelStyles, 'CheckboxLabel');
  return /*#__PURE__*/React.createElement("label", _extends({}, s('label'), {
    htmlFor: id
  }), Children.toArray(children).length > 0 ? prepend(label, Children.toArray(children)) : label);
}

var defaultStyles = StyleSheet({
  container: _objectSpread(_objectSpread({
    display: 'flex',
    alignItems: 'center'
  }, padding.styles({
    target: 'checkbox.container',
    y: 'xxxs',
    x: 'none'
  })), {}, {
    '& > *': {
      cursor: 'pointer'
    }
  }),
  containerDisabled: _objectSpread(_objectSpread({}, text.styles({
    target: 'checkbox.disabled',
    fallback: 'normal.default',
    color: function color(_ref2) {
      var token = _ref2.token;
      return token('color.textStyle.body.disabled');
    }
  })), {}, {
    '& > *': {
      cursor: 'default'
    }
  }),
  input: {
    position: 'absolute',
    clipPath: 'inset(0)',
    opacity: '0 !important',
    // TODO: Fix type
    // @ts-ignore
    '& + label': _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({
      position: 'relative',
      display: 'flex',
      flexShrink: '0',
      alignItems: 'center',
      justifyContent: 'center',
      transition: "background-color 200ms ease-in,\n                   border-color 200ms ease-in,\n                   transform 200ms cubic-bezier(0.175, 0.885, 0.32, 1.275)"
    }, text.styles({
      target: 'checkbox'
    })), padding.styles({
      target: 'checkbox'
    })), margin.styles({
      target: 'checkbox',
      all: 'xxxs',
      right: 'xs'
    })), border.styles({
      target: 'checkbox',
      all: {
        width: 'medium',
        radius: 'small',
        color: 'input.idle'
      }
    })), {}, {
      height: function height(_ref3) {
        var token = _ref3.token;
        return token('checkbox.height', token('checkbox.size', '1.6rem'));
      },
      width: function width(_ref4) {
        var token = _ref4.token;
        return token('checkbox.width', token('checkbox.size', '1.6rem'));
      },
      backgroundColor: function backgroundColor(_ref5) {
        var token = _ref5.token;
        return token('checkbox.background.color', token('color.input.idle'));
      },
      '&:hover': _objectSpread(_objectSpread({}, text.styles({
        target: 'checkbox.hover'
      })), border.styles({
        target: 'checkbox.hover',
        all: {
          color: 'input.hover'
        }
      })),
      '&:before': _objectSpread(_objectSpread(_objectSpread({
        position: 'absolute',
        content: '""',
        transition: "background-color 200ms ease-in,\n                     transform 200ms cubic-bezier(0.175, 0.885, 0.32, 1.275)"
      }, margin.styles({
        target: 'checkbox.tick',
        top: function top() {
          return '-.1rem';
        }
      })), border.styles({
        target: 'checkbox.tick',
        all: {
          width: function width() {
            return 0;
          },
          color: function color(_ref6) {
            var token = _ref6.token;
            return token('textStyle.body.contrast.color');
          }
        },
        bottom: {
          width: function width() {
            return '0.2rem';
          }
        },
        right: {
          width: function width() {
            return '0.2rem';
          }
        }
      })), {}, {
        display: function display(_ref7) {
          var token = _ref7.token;
          return token('checkbox.tick.display');
        },
        top: function top(_ref8) {
          var token = _ref8.token;
          return token('checkbox.tick.top', '50%');
        },
        left: function left(_ref9) {
          var token = _ref9.token;
          return token('checkbox.tick.left', '50%');
        },
        width: function width(_ref10) {
          var token = _ref10.token;
          return token('checkbox.tick.width', '.4rem');
        },
        height: function height(_ref11) {
          var token = _ref11.token;
          return token('checkbox.tick.height', '.8rem');
        },
        opacity: function opacity(_ref12) {
          var token = _ref12.token;
          return token('checkbox.tick.opacity', '0');
        },
        backgroundColor: function backgroundColor(_ref13) {
          var token = _ref13.token;
          return token('checkbox.tick.background.color', 'transparent');
        },
        transform: function transform(_ref14) {
          var token = _ref14.token;
          return token('checkbox.tick.transform', 'translate(-50%, -50%) rotate(45deg)');
        },
        transformOrigin: function transformOrigin(_ref15) {
          var token = _ref15.token;
          return token('checbox.tick.transformOrigin', 'center center');
        }
      })
    }),
    '&:checked + label': _objectSpread(_objectSpread(_objectSpread({}, text.styles({
      target: 'checkbox.checked'
    })), border.styles({
      target: 'checkbox.checked',
      all: {
        color: 'input.selected'
      }
    })), {}, {
      backgroundColor: function backgroundColor(_ref16) {
        var token = _ref16.token;
        return token('checkbox.checked.background.color', token('color.input.selected'));
      },
      '&:hover': _objectSpread(_objectSpread({}, text.styles({
        target: 'checkbox.checked.hover'
      })), border.styles({
        target: 'checkbox.checked.hover',
        all: {
          color: 'input.selected'
        }
      })),
      '&:before': _objectSpread(_objectSpread({}, border.styles({
        target: 'checkbox.checked.tick',
        all: {
          color: function color(_ref17) {
            var token = _ref17.token;
            return token('color.input.idle');
          }
        }
      })), {}, {
        opacity: function opacity(_ref18) {
          var token = _ref18.token;
          return token('checkbox.checked.tick.opacity', '1');
        },
        transform: function transform(_ref19) {
          var token = _ref19.token;
          return token('checkbox.checked.tick.transform');
        }
      })
    })
  },
  inputIndeterminate: {
    '& + label': {
      '&:before': _objectSpread(_objectSpread(_objectSpread({
        height: 0,
        transform: 'translate(-50%, -50%) rotate(0deg)'
      }, margin.styles({
        target: 'checkbox.indeterminate.tick',
        top: 'none'
      })), border.styles({
        target: 'checkbox.indeterminate.tick',
        all: {
          color: function color(_ref20) {
            var token = _ref20.token;
            return token('color.input.idle');
          }
        }
      })), {}, {
        width: function width(_ref21) {
          var token = _ref21.token;
          return token('checkbox.indeterminate.tick.width', '.6rem');
        }
      })
    }
  },
  inputError: {
    '& + label': _objectSpread(_objectSpread(_objectSpread({}, text.styles({
      target: 'checkbox.error'
    })), border.styles({
      target: 'checkbox.error',
      all: {
        color: 'input.error'
      }
    })), {}, {
      background: function background(_ref22) {
        var token = _ref22.token;
        return token('checkbox.error.background.color', token('color.input.idle'));
      },
      '&:hover': _objectSpread(_objectSpread({}, text.styles({
        target: 'checkbox.hover.error'
      })), border.styles({
        target: 'checkbox.hover.error',
        all: {
          color: 'input.error'
        }
      })),
      '&:before': {
        backgroundColor: function backgroundColor(_ref23) {
          var token = _ref23.token;
          return token('checkbox.checked.error.tick.background.color', token('color.input.error'));
        }
      }
    }),
    '&:checked + label': _objectSpread(_objectSpread(_objectSpread({}, text.styles({
      target: 'checkbox.checked.error'
    })), border.styles({
      target: 'checkbox.checked.error',
      all: {
        color: 'input.error'
      }
    })), {}, {
      backgroundColor: function backgroundColor(_ref24) {
        var token = _ref24.token;
        return token('checkbox.checked.error.background.color', token('color.input.error'));
      },
      '&:hover': _objectSpread(_objectSpread({}, text.styles({
        target: 'checkbox.checked.error.hover'
      })), border.styles({
        target: 'checkbox.checked.error.hover',
        all: {
          color: 'input.error'
        }
      })),
      '&:before': {
        backgroundColor: function backgroundColor(_ref25) {
          var token = _ref25.token;
          return token('checkbox.checked.error.tick.background.color', 'transparent');
        }
      }
    })
  },
  inputDisabled: {
    '& + label': _objectSpread(_objectSpread(_objectSpread({}, text.styles({
      target: 'checkbox.disabled'
    })), border.styles({
      target: 'checkbox.disabled',
      all: {
        color: 'input.disabled'
      }
    })), {}, {
      background: function background(_ref26) {
        var token = _ref26.token;
        return token('checkbox.disabled.background.color', token('color.input.disabled.default'));
      },
      '&:hover': _objectSpread(_objectSpread({}, text.styles({
        target: 'checkbox.hover.disabled'
      })), border.styles({
        target: 'checkbox.hover.disabled',
        all: {
          color: 'input.disabled'
        }
      }))
    }),
    '&:checked + label': _objectSpread(_objectSpread(_objectSpread({}, text.styles({
      target: 'checkbox.checked.disabled'
    })), border.styles({
      target: 'checkbox.checked.disabled',
      all: {
        color: 'input.disabled'
      }
    })), {}, {
      backgroundColor: function backgroundColor(_ref27) {
        var token = _ref27.token;
        return token('checkbox.checked.disabled.background.color', token('color.input.disabled.default'));
      },
      '&:hover': _objectSpread(_objectSpread({}, text.styles({
        target: 'checkbox.checked.disabled.hover'
      })), border.styles({
        target: 'checkbox.checked.disabled.hover',
        all: {
          color: 'input.disabled'
        }
      })),
      '&:before': _objectSpread(_objectSpread({}, border.styles({
        target: 'checkbox.checked.disabled.tick',
        all: {
          color: 'input.disabled'
        }
      })), {}, {
        backgroundColor: function backgroundColor(_ref28) {
          var token = _ref28.token;
          return token('checkbox.disabled.tick.background.color', 'transparent');
        }
      })
    })
  }
});
var displayName = 'Checkbox';
/**
 * Checkboxes allow users to select multiple items from a list of individual items, or to mark one individual item as selected. Can also be used as an indicator that an item is in an `indeterminate` state.
 */

export var Checkbox = /*#__PURE__*/forwardRef(function (_ref29, ref) {
  var _ref29$type = _ref29.type,
      type = _ref29$type === void 0 ? CHECKBOX : _ref29$type,
      containerProps = _ref29.containerProps,
      propId = _ref29.id,
      name = _ref29.name,
      value = _ref29.value,
      label = _ref29.label,
      _ref29$meta = _ref29.meta;
  _ref29$meta = _ref29$meta === void 0 ? {} : _ref29$meta;

  var error = _ref29$meta.error,
      _ref29$labelPosition = _ref29.labelPosition,
      labelPosition = _ref29$labelPosition === void 0 ? 'right' : _ref29$labelPosition,
      _ref29$disabled = _ref29.disabled,
      disabled = _ref29$disabled === void 0 ? false : _ref29$disabled,
      indeterminate = _ref29.indeterminate,
      prefix = _ref29.prefix,
      suffix = _ref29.suffix,
      checkIcon = _ref29.checkIcon,
      _ref29$onChange = _ref29.onChange,
      onChange = _ref29$onChange === void 0 ? noop : _ref29$onChange,
      _ref29$onBlur = _ref29.onBlur,
      onBlur = _ref29$onBlur === void 0 ? noop : _ref29$onBlur,
      children = _ref29.children,
      tabIndex = _ref29.tabIndex,
      _ref29$Container = _ref29.Container,
      Container = _ref29$Container === void 0 ? 'span' : _ref29$Container,
      description = _ref29.description,
      _ref29$setRef = _ref29.setRef,
      setRef = _ref29$setRef === void 0 ? noop : _ref29$setRef,
      inputProps = _objectWithoutProperties(_ref29, ["type", "containerProps", "id", "name", "value", "label", "meta", "labelPosition", "disabled", "indeterminate", "prefix", "suffix", "checkIcon", "onChange", "onBlur", "children", "tabIndex", "Container", "description", "setRef"]);

  var s = useStyles(defaultStyles, displayName);
  var id = useRef(propId !== null && propId !== void 0 ? propId : uniqueId());
  var inputRef = useRef(null);
  var handleChange = useCallback(function (e) {
    onChange(e);
    onBlur(e);
  }, [onChange, onBlur]);
  useImperativeHandle(ref, function () {
    return inputRef.current;
  }, []);
  useEffect(function () {
    var _context;

    console.warn("".concat(_filterInstanceProperty(_context = [description && 'description', setRef && 'setRef']).call(_context, Boolean).join(', '), " props are deprecated and will be ignored"));
  }, [description, setRef]);
  return /*#__PURE__*/React.createElement(Container, _extends({}, containerProps, s('container', {
    containerDisabled: disabled
  }), !isString(Container) && {
    styles: s
  }), labelPosition === 'left' ? /*#__PURE__*/React.createElement(CheckboxLabel, {
    id: id,
    label: label
  }, children) : null, prefix && /*#__PURE__*/React.createElement("span", null, prefix), /*#__PURE__*/React.createElement("input", _extends({}, inputProps, s('input', {
    inputIndeterminate: indeterminate,
    inputError: !!error,
    inputDisabled: disabled
  }), {
    ref: inputRef,
    type: type,
    id: id.current,
    name: name,
    disabled: disabled,
    checked: value,
    onChange: handleChange,
    tabIndex: -1
  })), /*#__PURE__*/React.createElement("label", {
    htmlFor: id.current,
    tabIndex: tabIndex || 0,
    onKeyDown: function onKeyDown(e) {
      if (!disabled && (e.key === 'Enter' || e.key === ' ')) {
        var _inputRef$current;

        e.preventDefault();
        (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 ? void 0 : _inputRef$current.click();
      }
    }
  }, checkIcon && checkIcon), labelPosition === 'right' ? /*#__PURE__*/React.createElement(CheckboxLabel, {
    id: id.current,
    label: label
  }, children) : null, suffix && /*#__PURE__*/React.createElement("span", null, suffix));
});
Checkbox.displayName = displayName;
export { CHECKBOX, RADIO };
export default Checkbox;